import React from "react";
import { useConsumerStore } from "../../../store";

function useUserInfo() {
  const user = useConsumerStore((state) => state.consumer);
  return React.useMemo(() => user, [user]);
}

export default useUserInfo;
